import { render, staticRenderFns } from "./SlotMember.vue?vue&type=template&id=32216b03&scoped=true&"
import script from "./SlotMember.vue?vue&type=script&lang=js&"
export * from "./SlotMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32216b03",
  null
  
)

export default component.exports